<template>
  <div
    class="qmkey-org-chart-process-content"
  >
    <!-- HEADER --> 
    <div class="qmkey-process-org-selector">
      <!-- STANDARD SELECTOR -->
      <v-tabs
        v-model="tab"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="qstandard in standard"
          :key="qstandard.id"
        >
          {{ qstandard.name }}
        </v-tab>
        <!-- ADD STANDARD -->
        <v-icon
          v-if="isAdmin"
          @click="add_standard"
        >
            mdi-plus
          </v-icon>
      </v-tabs>
      <!-- VIEWS -->
      <v-btn
        color="primary"
        icon
        @click="update_view"
      >
        <v-icon medium v-if="view != 'OrgChart'">{{ 'mdi-family-tree' }}</v-icon>
        <v-icon medium v-else>{{ 'mdi-format-list-checkbox' }}</v-icon>
      </v-btn>
    </div>

    <!-- BODY -->
    <div class="qmkey-org-chart-process-body" >
      <!-- PROCESS CONTENT -->
      <div v-if="view == 'OrgChart'">
        <ProcessDataOrgChart
          v-if="selected_process && selected_process.id > 0 && selected_process.id != current_standard.id"
          :key="render_process"
          :drawer="data_drawer"
          :process="selected_process"
          :roles="roles"
          :departments="departments"
          class="qmkey-process-map-drawer"
          @refresh="refresh"
          @edit_process="edit_process(selected_process)"
          @delete_process="delete_process(selected_process)"
        ></ProcessDataOrgChart>
        

        <v-btn
          v-if="selected_process && selected_process.id > 0 && selected_process.id != current_standard.id"
          color="primary"
          icon
          @click.stop="toggle_drawer"
          class="qmkey-data-process-activator"
          :class="data_drawer ? 'org-chart-data-opened' : ''"
        >
          <v-icon>
            {{ data_drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
          </v-icon>
        </v-btn>
    </div>
      <!-- ORGANIZATION CHART -->
      <v-tabs-items
        v-model="tab"
        class="qmkey-process-org-chart"
        :class="data_drawer && view == 'OrgChart' ? 'org-chart-data-opened' : ''"
      >
        <div
          v-if="view == 'OrgChart'"
          class="qmkey-process-org-chart"
        >
          <OrganizationChart
            ref="OrgChart"
            v-if="current_standard"
            :datasource="current_standard"
            zoom
            pan
            expandable
            @node-click="node_click"
            class="qmkey-org-chart-comp"
          >
            <template slot-scope="{ nodeData, classData}">
              <v-card
                class="qmkey-org-chart-node-card"
                style="border-radius: 15px;"
                :ref="!nodeData.standard && nodeData.id > 0 ? 'standard' : ''"
                :class="[(nodeData.class || ''),(nodeData.id > 0 && nodeData.id ? classData : '')]"
              >
                <!-- CONTENT -->
                <div>
                  <!-- HEADER -->
                  <div>
                    <div
                      class="qmkey-org-chart-process-card-header"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                        
                          v-bind="attrs"
                          v-on="on"
                          style="cursor:default;"
                          class="string-field-content"
                        >{{ nodeData.name }}</span>
                        
                      </template>
                      {{ nodeData.name }}
                    </v-tooltip>
                    </div>
                  </div>
                  <!-- FOOTER -->
                  <div 
                    class="qmkey-org-chart-process-card-footer" 
                    v-if="isAdmin"
                  >
                    <v-icon
                      v-if="!(nodeData.id == current_standard.id)"
                      @click.stop=add_process(nodeData)
                      medium
                    >
                      mdi-plus
                    </v-icon>
                  </div>

                </div>

                <!-- ADD -->
                
              </v-card>
            </template>
          </OrganizationChart>
        </div>
        <div v-else-if="view == 'Table'">
          <ProcessTable
            ref="Table"
            :processes="current_standard"
            :processes_types="process_types"
            :roles="roles"
            :departments="departments"
            @refresh="refresh"
            @add_process="add_process"
            @edit_process="edit_process"
            @delete_process="beforeDeleteProcess"
          />
        </div>
      </v-tabs-items>
    </div>
    <ModalDialog
      :showModalDialog="show_dialog"
      :title="modal_title"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      return_object
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </ModalDialog>
    <!-- DELETE CONFIRMATION -->
    <v-dialog
      v-model="confirmation_dialog"
      @input="submit_action"
    >
      <v-card>
        <v-card-title
          class="modal-card-title width-50"
        >
          <span class="qmkey-modal-h1 pb-0">{{ modal_title }}</span>
          <v-spacer></v-spacer>
          <v-btn
            class="qmkey-modal-dialog-close"
            text
            plain
            right
            small
            :ripple="false"
            @click="confirmation_dialog = false"
          >
            <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions class="qmkey-modal-dialog-card-actions">
        <v-spacer></v-spacer>
          <v-btn
            class="qmkey-modal-dialog-button-secundary"
            text
            @click="toggle_confirmation"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            text
            @click="submit_action"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<style lang="scss">
 @import "@/sass/orgchart.scss";

 .qmkey-process-org-selector {
   width: 100%;
   display: flex;
   align-content: center;
   height: 6%
 }

 .qmkey-data-process-activator {
   background-color: #ffe;
   position: absolute; 
   z-index: 2;
 }

 .qmkey-orgchart-found {
   background: $primary !important;
 }

 .org-chart-data-opened {
   left: 40%;
 }
 .org-chart-data-opened.qmkey-org-chart-comp {
   width: 60%;
 }

 .qmkey-org-chart-process-content {
   height: 100%;
 }

 .qmkey-process-org-chart {
   width: 100%;
   height: 100%;
 }

 .qmkey-org-chart-node-card {
   width: 100% !important;
   padding: 0.5vw;
   font-size: medium;
 }

 .qmkey-org-chart-node-card.inactive {
   background-color: lightgrey;
 }

 .qmkey-org-chart-node-card.active {
   background-color: $secondary !important;
 }

 .qmkey-org-chart-process-body {
   display: flex;
   height: 94%;
 }

 .qmkey-org-chart-process-card-header {
   text-wrap: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
 }

 .qmkey-org-chart-process-card-footer {
   display: flex;
   justify-content: center;
 }

 .qmkey-static-node {
   border-radius: 100% !important;
   background-color: $primary !important;
 }

 .qmkey-org-node-process {
   background-color: $secondary;
 }

 .orgchart .node .qmkey-static-node .active {
   background-color: $primary !important;
 }
</style>


<script>
 import { mapGetters } from 'vuex';
 import OrganizationChart from '@/components/org_chart/OrganizationChart';
 import QTree from '@/utils/QTree';
 import Process from '@/api/Process';
 import ProcessPermission from '@/api/ProcessPermission';
 import QStandard from '@/api/Standard';
 import SearchText from '@/components/SearchText';
 import ModalDialog from '@/components/explorer/ModalDialog';
 import Select from '@/components/inputs/Select';
 import TextInput from '@/components/inputs/Select';
 import ProcessDataOrgChart from '@/components/process/ProcessDataOrgChart';
 import ProcessTable from '@/components/process/ProcessTable';;

 function deepcopy(obj) {
   return JSON.parse(JSON.stringify(obj));
 }

 function object_to_formdata(obj) {
   const fd = new FormData();
   for (const [key, value] of Object.entries(obj)) {
     fd.append(key, value);
   }
   return fd;
 }

 export default {
   name: 'ProcessesOrgChart',

   components: {
     OrganizationChart,
     SearchText,
     ModalDialog,
     Select,
     TextInput,
     ProcessDataOrgChart,
     ProcessTable
   },


   props: {
     standard: {},
     roles: {},
     departments: {},
     allProcesses: {},
     view: String,
   },
   
   data: () => ({
     tab: 0,
     show_dialog: false,
     modal_title: '',
     submit_button_caption: 'Añadir',
     submit_action: (() => {}),
     parent_subprocess: false,
     fields_to_collect:[],
     parent_process: null,
     selected_process: null,
     selected: null,
     data_drawer: false,
     process_types: [
       {
         id: -2,
         value: 'C',
         name: 'views.processes.process_types.core',
         static: true,
         class: 'qmkey-static-node darken-1'
       },
       {
         id: -3,
         value: 'E',
         name: 'views.processes.process_types.strategic',
         static: true,
         class: 'qmkey-static-node darken-1'
       },
       {
         id: -4,
         value: 'S',
         name: 'views.processes.process_types.support',
         static: true,
         class: 'qmkey-static-node darken-1'
       }
     ],
     internal_type: [
       [
         'public',
         'views.processes.internal_type.public'
       ],
       [
         'restricted',
         'views.processes.internal_type.restricted'
       ]
     ],
     process_tab: 0,
     process_data_tabs: [
       'views.processes.tabs.data',
       'views.processes.tabs.permissions'
     ],
     new_permission: null,
     render_process: 0,
     confirmation_dialog: false,
   }),

   computed: {
     ...mapGetters(['isAdmin', 'site_id']),

     process_tree() {
       return new QTree(this.allProcesses);
     },

     _selected() {
       // Returns this.selected or an empty object
       return this.selected || {};
     },

     _parent_process() {
       // Returns this.parent_process or an empty object
       return this.parent_process || {};
     },

     process_standard() {
       return Object.fromEntries(
         this.standard.map(st => [
           st.id,
           (this.process_tree
                .get_root_objects()
                .filter(pr => pr.standard === st.id))
         ]));
     },

     process_entries() {
       const filter_procs = (proc) => {
         if (proc.id === this._selected.id)
           // Discard selected process from the entry select
           return false;
         const my_type = (
           this._selected.process_type
           || this._parent_process.process_type
         );
         return (proc.process_type === my_type);
       }

       const roots = this.process_tree.get_root_objects().filter(filter_procs);
       const sorted_roots = this.sortArrayBy(roots, 'name')
       return sorted_roots.map((proc) => [proc.id, proc.name]);
     },

     local_standards() {
       return deepcopy(this.standard||{}).map(it => (
         Object.assign(it, {
           children: this.process_type_tree(it),
           "class": 'qmkey-static-node darken-2',
         })
       ));
     },

     current_standard() {
       return this.local_standards[this.tab];
     },

     allRoles() {
       return (this.roles || []).map(it => [it.value, it.text]);
     },
     
     process_fields() {
       return [
         // ROW 1
         [{
           component: "AutocompleteSelect",
           id: "internal_type",
           label: this.$t('views.processes.process_fields.internal_type'),
           placeholder: this.$t('views.processes.process_fields.internal_type_placeholder'),
           required: true,
           cols: 4,
           items: this.internal_type.map(it => ([it[0], this.$t(it[1])])),
           value: this._selected.internal_type || 'public',
         },
          {
            component:"TextInput",
            id: "bp_reference",
            label: this.$t('views.processes.process_fields.bp_reference'),
            placeholder: this.$t('views.processes.process_fields.bp_reference_placeholder'),
            required: false,
            cols: 4,
            value: this._selected.bp_reference
          },
          {
            component: "AutocompleteSelect",
            id: "inherit_permissions",
            label: this.$t('views.processes.process_fields.inherit_permissions'),
            placeholder: "Select If Process inherit roles/permissions",
            required: true,
            cols: 4,
            items: [['true', this.$t('confirm')], ['false',this.$t('denny')]],
            readonly: !(this._parent_process.id >= 0),
            value: this._selected.inherit_permissions || 'false',
         }],

         // ROW 2
         [{
           component: "TextInput",
           id: "reference",
           label: this.$t('views.processes.process_fields.reference'),
           placeholder: this.$t('views.processes.process_fields.reference_placeholder'),
           required: true,
           cols: 4,
           value: this._selected.reference
         },
          {
            component:"TextInput",
            id: "name",
            label: this.$t('views.processes.process_fields.name'),
            placeholder: this.$t('views.processes.process_fields.name_placeholder'),
            required: true,
            cols: 4,
            value: this._selected.name
          },
          {
            component: "AutocompleteSelect",
            id: "process_type",
            label: this.$t('views.processes.process_fields.process_type'),
            placeholder: this.$t('views.processes.process_fields.process_type_placeholder'),
            required: true,
            cols: 4,
            // If has value not editable, if not value, select it
            readonly: (
              this._selected.process_type
              || this._parent_process.process_type
              || this._parent_process.value
            ),
            items: this.process_types.map(it => ([it.value, this.$t(it.name)])),
            value: (
              this._selected.process_type
              || this._parent_process.process_type
              || this._parent_process.value
            ),
         }],

         // ROW 3
         [{
           component: "TextareaInput",
           id: "description",
           label: this.$t('views.processes.process_fields.description'),
           placeholder: this.$t('views.processes.process_fields.description_placeholder'),
           required: false,
           cols: 4,
           value: this._selected.description
         },
          {
            component:"TextareaInput",
            id: "entries",
            label: this.$t('views.processes.process_fields.entries'),
            placeholder: this.$t('views.processes.process_fields.entries_placeholder'),
            required: false,
            cols: 4,
            value: this._selected.entries
          },
          {
            component: "TextareaInput",
            id: "outputs",
            label: this.$t('views.processes.process_fields.outputs'),
            placeholder: this.$t('views.processes.process_fields.outputs_placeholder'),
            required: false,
            cols: 4,
            value: this._selected.outputs
         }],

         // ROW 4
         [{
           component: "TextareaInput",
           id: "activities",
           label: this.$t('views.processes.process_fields.activities'),
           placeholder: this.$t('views.processes.process_fields.activities_placeholder'),
           required: false,
           cols: 4,
           value: this._selected.activities
         },
          {
            component:"TextareaInput",
            id: "objective",
            label: this.$t('views.processes.process_fields.objective'),
            placeholder: this.$t('views.processes.process_fields.objective_placeholder'),
            required: false,
            cols: 4,
            value: this._selected.objective
          },
          {
            component: "TextareaInput",
            id: "scope",
            label: this.$t('views.processes.process_fields.scope'),
            placeholder: this.$t('views.processes.process_fields.scope_placeholder'),
            required: false,
            cols: 4,
            value: this._selected.scope
         }],

         // ROW 5
         [{
           component: "AutocompleteSelect",
           id: "process_entries",
           label: this.$t('views.processes.process_fields.entries'),
           placeholder: this.$t('views.processes.process_fields.entries_placeholder'),
           required: false,
           cols: 12,
           multiple: true,
           items: this.process_entries,
           value: this._selected.process_entries,
         }],

         // ROW 6
         [{
           component: "AutocompleteSelect",
           id: "roles::RESPONSIBLE",
           label: this.$t('views.processes.process_fields.responsible_roles'),
           placeholder: this.$t('views.processes.process_fields.responsible_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).RESPONSIBLE,
         }, {
           component:"AutocompleteSelect",
           id: "roles::CREATOR",
           label: this.$t('views.processes.process_fields.creator_roles'),
           placeholder: this.$t('views.processes.process_fields.creator_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).CREATOR,
         }, {
           component: "AutocompleteSelect",
           id: "roles::EDITOR",
           label: this.$t('views.processes.process_fields.editor_roles'),
           placeholder: this.$t('views.processes.process_fields.editor_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).EDITOR,
         }],

         // ROW 7
         [{
           component: "AutocompleteSelect",
           id: "roles::READER",
           label: this.$t('views.processes.process_fields.reader_roles'),
           placeholder: this.$t('views.processes.process_fields.reader_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).READER,
         }, {
           component: "AutocompleteSelect",
           id: "roles::ORIGINAL_DOCUMENT",
           label: this.$t('views.processes.process_fields.original_document_reader_roles'),
           placeholder: this.$t('views.processes.process_fields.original_document_reader_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).ORIGINAL_DOCUMENT,
         }, {
           component: "AutocompleteSelect",
           id: "roles::PDF_READER",
           label: this.$t('views.processes.process_fields.visor_pdf_reader_roles'),
           placeholder: this.$t('views.processes.process_fields.visor_pdf_reader_roles_placeholder'),
           required: false,
           cols: 3,
           items: this.allRoles,
           multiple: true,
           value: (this._selected.roles || {}).PDF_READER,
         }],
       ]
     },
   },


   methods: {
     toggle_drawer() {
       this.data_drawer = !this.data_drawer;
     },
     toggle_confirmation() {
       this.confirmation_dialog = !this.confirmation_dialog;
     },
     node_click(process_clicked){
       if (process_clicked.id <= 0 || process_clicked.id == this.current_standard.id) {
         this.data_drawer = false;
       }
       this.selected_process = process_clicked;
     },

     /* GET ALL STANDARD TREE */
     process_type_tree(standard) {
       const pt = this.process_types.map((it) => ({
         ...it,
         name: this.$t(it.name),
       }));
       return deepcopy(pt).map(it => (
         Object.assign(it, {
           children: (
             this.process_standard[standard.id].filter((tr) => (
               (tr.process_type == it.value)
               && (tr.standard == standard.id)
           ))),
         })
       ));
     },

     sortArrayBy(array, param) {
       return array.sort((a, b) => {
         if (a[param] > b[param]) {
           return 1;
         } else if (a[param] === b[param]) {
           return 0;
         } else {
           return -1;
         }
       });
     },
     
     
     /* ADD STANDARD */
     add_standard() {
       this.fields_to_collect = [
         [{
           id:	"name",
           label: this.$t('views.processes.process_fields.name'),
           required:	true,
           value:	null,
           cols:	4,
           class:	null,
           component:	"TextInput",
           placeholder: this.$t('views.processes.standard.name_placeholder')
         }]
       ],
       this.modal_title = this.$t('views.processes.standard.add');
       this.submit_action = (objdata) => {this.addStandard(objdata)}
       this.toggle_dialog();
     },

     async addStandard(objdata) {
       const formdata = object_to_formdata(objdata);
       this.loading = true;
       this.message = '';

       try {
         await QStandard.createQStandard(this.site_id, formdata);
       } catch (err) {
         this.loading = false;
         this.render_form_errors(err);
         return;
       }

       this.loading = false;
       this.$emit('refresh');
       this.toggle_dialog();
     },

     process_roles_in_objdata(objdata) {
       // Move any {"roles::KEY": [...]} to roles: {KEY: [...]} in objdata
       // Deletes the "roles::KEY" keys in objdata
       // Modifies the original objdata
       // Returns objdata
       objdata.roles = {};
       for (const key of Object.keys(objdata)) {
         if (key.indexOf('roles::') == 0) {
           objdata.roles[key.split('::')[1]] = objdata[key];
           delete objdata[key];
         }
       }
       return objdata;
     },

     /* ADD PROCESS */

     add_process(parent_process) {
       this.selected = null;
       this.parent_process = parent_process;
       this.parent_subprocess = parent_process.id;
       this.modal_title = this.$t('views.processes.add_process');
       this.$nextTick(() => {
         this.fields_to_collect = this.process_fields
         this.submit_button_caption = this.$t('add')
         this.submit_action = this.addProcess;
         this.toggle_dialog();
       });
     },

     async addProcess(objdata) {
       objdata.standard = this.current_standard.id;
       if (this.parent_subprocess > 0) {
         objdata.parent = this.parent_subprocess;
       }
       this.loading = true;

       objdata = this.process_roles_in_objdata(objdata);

       try {
         await Process.create(this.site_id, objdata);
       } catch (err) {
         this.render_form_errors(err);
         this.loading = false;
         return;
       }

       this.toggle_dialog();
       this.showProcessRoles = false
       this.loading = false
       this.refresh();
     },

     edit_process(selected){
       this.selected = selected;
       this.parent_subprocess = null;

       this.$nextTick(() => {
         this.fields_to_collect = this.process_fields;
         this.modal_title = `${this.$t('views.processes.edit_process')} ${selected.name} ?`;
         this.submit_button_caption = this.$t('dialog.save')
         this.submit_action = (formData) => {this.process_edit(formData);}
         this.toggle_dialog();
       });
     },

     async process_edit(objdata) {
       objdata.standard = this.current_standard.id;
       if (this.parent_subprocess > 0) {
         objdata.parent = this.parent_subprocess;
       }
       this.loading = true;

       // Object needs all properties, even the ones with null values, because
       // we will override to the process and the ModalDialog doesn't return
       // the null values.
       for (const prop of this.fields_to_collect.flat()) {
         if (!Object.hasOwn(objdata, prop.id) && objdata[prop.id] === null) {
           if (prop.component == "AutocompleteSelect") {
             objdata[prop.id] = [];
           } else {
             objdata[prop.id] = null;
           }
         }
       }

       objdata = this.process_roles_in_objdata(objdata);

       const process_obj = {...this.selected, ...objdata};

       try {
         await Process.update(this.site_id, process_obj.id, process_obj);
       } catch (err) {
         this.render_form_errors(err)
         this.loading = false;
         return;
       }

       this.toggle_dialog();
       this.showProcessRoles  = false
       this.loading = false
       this.refresh();
     },

     beforeDeleteProcess(process) {
       this.modal_title = `${this.$t('views.processes.delete_process')} '${process.name}' ?`;
       this.submit_action = () => this.delete_process(process);
       this.toggle_confirmation();
     },

     async delete_process(selected) {
       this.loading = true;
       try {
         await Process.delete(this.site_id, selected.id);
       } catch (err) {
         console.error(err)
         this.loading = false;
         return;
       }
       this.loading = false;
       this.toggle_confirmation();
       this.refresh();
     },

     toggle_dialog() {
       this.show_dialog = !this.show_dialog;
       // if don't do that computed process_field returns wrong values
       if (! this.show_dialog) {
         this.selected = null;
       }
     },

     refresh() {
       this.$emit('refresh');
     },

     update_view() {
       let view = 'OrgChart';
       if (this.view == 'OrgChart') {
         view = 'Table';
       }
       this.$emit('update_view',view)
     },

     beforeDeletePermission(selected) {
       this.selected_permission = selected;
       this.modal_title = `${this.$t('views.processes.delete_permission')} ${selected.permission_id} ?`;
       this.submit_action = (objdata) => this.deletePermission(objdata);
       this.toggle_confirmation();
     },

     async deletePermission() {
       try {
         await ProcessPermission.delete(this.site_id, this.selected_permission.id);
       } catch (err) {
         console.error(err);
         return;
       }
       this.toggle_confirmation();
       this.$emit('refresh');
     },
   },

   watch: {
     tab() {
       this.selected = null;
       this.selected_process = null;
     },
   },
 }
</script>
